var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoExploreRewards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.003 13.5a1 1 0 0 0-.655.244l-7.055 6.113a1 1 0 0 0-.067 1.448L23.421 34.02a1 1 0 0 0 .865.479 1 1 0 0 0 .865-.479l12.194-12.716a1 1 0 0 0-.067-1.448l-7.055-6.113a1 1 0 0 0-.654-.244zm7.813 15.895 7.398-7.715h-4.616zm7.204-9.715-4.824-4.18h-2.927l3.127 4.18zm-11.7-4.18h-2.944l-4.824 4.18h4.625l3.142-4.18Zm-7.963 6.18 7.422 7.74-2.804-7.74zm9.938-5.48 2.604 3.48h-5.22zm0 14.291-3.193-8.81h6.37z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExploreRewards);
export default __webpack_public_path__ + "static/media/IcoExploreRewards.bdf7d8065f5d54d0a41e8478a6484645.svg";
export { ForwardRef as ReactComponent };